import React, { Component, Fragment } from "react";
import {
    getStrategyName,
    SalamanderStrategy,
    SalamanderSubStrategy,
    SalamanderSubStrategyAndMetaData,
    MailroomOptions
} from "../../models/SchoolMailroomConfigDto";
import {Dropdown, IDropdownOption} from "office-ui-fabric-react";
import * as _ from "lodash";
import { ISelectableOption } from "office-ui-fabric-react";
import LoadingSection from "../LoadingSection";
import {Rule} from "../../models/mailroom-school-config-rules/Rule";
import {OptionWithRequirements} from "../../models/mailroom-school-config-rules/OptionWithRequirements";

export interface SalamanderStrategyEditorProps {
    strategy: SalamanderStrategy;
    configRules: Rule[];
    options?: MailroomOptions;
    onStrategyChanged(newStrategy: SalamanderStrategy): void;
    disabled: boolean;
}

export interface SalamanderStrategyEditorState {
    options?: MailroomOptions;
}

export class SalamanderStrategyEditor extends Component<SalamanderStrategyEditorProps, SalamanderStrategyEditorState> {

    constructor(props: SalamanderStrategyEditorProps) {
        super(props);

        this.state = {
        };
    }

    public async componentDidMount() {
    }

    public componentDidUpdate(prevProps: Readonly<SalamanderStrategyEditorProps>, prevState: Readonly<SalamanderStrategyEditorState>, snapshot?: any) {
        
    }

    private updateSubstrategy(groupName: string, subStrategyName: string, option?: IDropdownOption) {

        if (option) {
            const editedStrategy = _.cloneDeep(this.props.strategy);

            editedStrategy[groupName][subStrategyName] = option.data.option;


            this.props.onStrategyChanged(editedStrategy);
        }
    }

    private onRenderOption(option: ISelectableOption | undefined): JSX.Element {

        const optionAndMetaData = option?.data as SalamanderSubStrategyAndMetaData;


        
        return (
            <div className={optionAndMetaData.metaData.hasObsoleteAttribute ? "dropdown-option--red" : ""}>
                <div className={"dropdown-option__header"}>{optionAndMetaData?.option.description}</div>
                <div>{getStrategyName(optionAndMetaData?.option.$type)}</div>
                <div>{optionAndMetaData.metaData.hasObsoleteAttribute ? "Obsolete" : ""}</div>
            </div>
        );
    };
    
    private buildDropdown(groupName: string, subStrategyName: string, subStrategyOptions: SalamanderSubStrategyAndMetaData[],dropdownDisabled: boolean) {

        const options: IDropdownOption[] = subStrategyOptions.map(subStrategyAndMetaData => {
            return {
                key: subStrategyAndMetaData.option.$type,
                text: `${subStrategyAndMetaData.option.description}`,
                data: subStrategyAndMetaData
            };
        });

        const currentlySelectedSubStrategy: SalamanderSubStrategy = this.props.strategy[groupName][subStrategyName] as SalamanderSubStrategy;
        const currentlySelectedSubStrategyMetaData = subStrategyOptions.find(o => o.option.$type == currentlySelectedSubStrategy.$type)!.metaData;

        return (
            <Dropdown
                key={`${groupName}_${subStrategyName}`}
                className={currentlySelectedSubStrategyMetaData.hasObsoleteAttribute ? "dropdown--red" : ""}
                selectedKey={currentlySelectedSubStrategy.$type}
                options={options}
                label={subStrategyName}
                onRenderOption={this.onRenderOption}
                styles={{
                    dropdownItemSelected: { height: 75 },
                    dropdownItem: { height: 75 }
                }}
                disabled={dropdownDisabled || this.props.disabled}
                onChange={(e: any, option?: IDropdownOption) => this.updateSubstrategy(groupName, subStrategyName, option)}
            />
        );
    }

    private buildDropdowns(groupName: string, rules: Rule[])
    {
        const dropdowns = rules.map(rule => {

            const options = rule.options as OptionWithRequirements<SalamanderSubStrategyAndMetaData>[];
            return this.buildDropdown(groupName,rule.path[2],options.map(o => o.option),rule.obsolete);
        });

        return (
            <Fragment>
                {dropdowns}
            </Fragment>
        );
    }

    private buildDropdownGroups(configRules: Rule[], options: MailroomOptions) {
        
        var strategySectionsToShow = new Set(["teachers", "students"])
        
        Object.keys(options).forEach(key => {
            //If option is false dont show anything
            if (!options[key]) {
                return
            }
            
            switch (key) {
                case "includeTeachingClasses":
                    strategySectionsToShow.add("classes")
                    break;
                case "includeParentGuardian":
                    strategySectionsToShow.add("guardians")
                    break;
                case "includeRegClasses":
                    strategySectionsToShow.add("regGroups")
                    break;
                case "includeYearClasses":
                    strategySectionsToShow.add("regGroups").add("yearGroups")
                    break;
                case "includeHouseClasses":
                    strategySectionsToShow.add("pastoralHouses")
                    break;
                case "includeSubjectYearClasses":
                    strategySectionsToShow.add("subjectYearGroups")
                    break;
                case "includeTeacherPhotos":
                    strategySectionsToShow.add("profilePhotos")
                    break;
                case "includeStudentPhotos":
                    strategySectionsToShow.add("profilePhotos")
                    break;
                case "includeClubClasses":
                    strategySectionsToShow.add("clubs")
                    break;
                case "includeUDGClasses":
                    strategySectionsToShow.add("userDefinedGroups")
                    break;
            }
        });
        
        
        const allSubStrategyRules = configRules.filter(c => c.path[0] === "strategy" && c.path.length === 3);
        const groupedSubStrategyRules = _.groupBy(allSubStrategyRules,c => c.path[1]);
        
        const groups = Object.keys(groupedSubStrategyRules)
            .filter(groupName => {
                return strategySectionsToShow.has(groupName);
            })
            .map(groupName => {
                
                const rules = groupedSubStrategyRules[groupName];
                return (
                    <div key={groupName}>
                        <h4 style={{textTransform: "capitalize"}}>{groupName}</h4>
                        {this.buildDropdowns(groupName, rules)}
                    </div>
                );
            });
        
        return (
            <Fragment>
                {groups}
            </Fragment>
        );
    }

    public render() {
        
        return ( 
            <LoadingSection dependantObjects={[this.props.options]} >
                <Fragment>
                    {this.buildDropdownGroups(this.props.configRules,this.props.options!)}
                </Fragment>
            </LoadingSection>
        );
    }
}
